import { render, staticRenderFns } from "./officeOrderDeliveryList.vue?vue&type=template&id=5ae2e63e&scoped=true"
import script from "./officeOrderDeliveryList.vue?vue&type=script&lang=js"
export * from "./officeOrderDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./officeOrderDeliveryList.vue?vue&type=style&index=0&id=5ae2e63e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2e63e",
  null
  
)

export default component.exports